import { z } from "zod";

export const payerSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.string().datetime(),
  deletedAt: z.string().datetime().nullable(),
  updatedAt: z.string().datetime().nullable(),
  stediId: z.string().nullable(),
  primaryPayerId: z.string().nullable(),
  name: z.string(),
  otherName: z.array(z.string()).nullable(),
  aliases: z.array(z.string()).nullable(),
  coverageTypes: z.array(z.string()).nullable(),
});

export type Payer = z.infer<typeof payerSchema>;

export const payerShape: Payer = {
  id: "",
  createdAt: "",
  deletedAt: null,
  updatedAt: "",
  stediId: null,
  primaryPayerId: null,
  name: "",
  otherName: null,
  aliases: null,
  coverageTypes: null,
};

export const getPayerDisplayName = (payer: Payer) => {
  const name = payer.name || "";

  return payer.primaryPayerId ? `${payer.primaryPayerId} - ${name}` : name;
};
